<template>
  <sui-page>
    <sui-page-header :title="pageTitle" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DEPT_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-6">
            <sui-text-field
              v-model="frame0.deptNmSearchText"
              maxlength="100"
              class="width100"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="btn_wrap">
            <sui-button
              v-permission:read="'PGE_CMY_00005'"
              type="button"
              class="comm_btn_Scr"
              @click="onSearchClick"
            >
              {{ $t("MSG_BTN_SEARCH") }}
            </sui-button>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <sui-tree
        ref="deptTree"
        v-bind="filteredTreeData"
        class="brdG01 pd20"
        style="height:450px; overflow:auto;"
        :editable="false"
        :multiple="true"
        :show-checkbox="true"
        :allow-batch="false"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancelClick"
        >
          {{ this.$t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onSelectClick"
        >
          {{ this.$t('MSG_BTN_SELT') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>

<script>
export default {
  name: 'PGE_CMY_00005', // eslint-disable-line vue/name-property-casing
  props: {
    closePagePopup: {
      type: Function,
      default: null,
    },
    pageInitialData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pageTitle: this.$t('MSG_TIT_DEPT_SRCH'),
      treeData: {
        data: [],
      },
      frame0: {
        deptNmSearchText: '',
      },
    };
  },

  computed: {
    filteredTreeData() {
      const filteredTreeData = {};
      const filterText = this.frame0.deptNmSearchText || '';
      const treeData = JSON.parse(JSON.stringify(this.treeData.data));

      treeData.forEach(item => {
        const descendants = this.getDescendantDepts(item);
        descendants.forEach(descendant => {
          const isMatched = descendant.text.indexOf(filterText) > -1;
          if (!isMatched) {
            const descendantDescendants = this.getDescendantDepts(descendant);
            const isDescendantMatched = descendantDescendants.some(descendantDescendant => descendantDescendant.text.indexOf(filterText) > -1);
            if (!isDescendantMatched) {
              descendant.isInvalid = true;
            }
          }
        });
        const isMatched = item.text.indexOf(filterText) > -1;
        if (!isMatched) {
          const isDescendantMatched = descendants.some(descendant => descendant.text.indexOf(filterText) > -1);
          if (!isDescendantMatched) {
            item.isInvalid = true;
          }
        }
      });

      filteredTreeData.data = treeData;
      return filteredTreeData;
    },
  },

  mounted() {
    this.onSearchClick();
  },

  methods: {
    onSearchClick() {
      http.request(this.$options.name, 'DTS_CMY_00009', {
      }).then(res => {
        this.setTreeData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    setTreeData(data) {
      const rootNode = utils.getMakeTreeData({
        id: 'departmentId',
        parentId: 'upDepartmentId',
        level: 'departmentLevel',
        value: 'departmentName',
        text: '{{departmentName}}',
      }, data, true);

      this.treeData = { data: rootNode };
    },
    getDescendantDepts(node) {
      const thisVue = this;
      const descendants = [];

      if (node != null) {
        if (node.children.length > 0) {
          node.children.forEach(child => {
            descendants.push(child);
            const descendantChildren = thisVue.getDescendantDepts(child);
            descendantChildren.forEach(descendantChild => {
              descendants.push(descendantChild);
            });
          });
        }
      }

      return descendants;
    },
    onCancelClick() {
      this.closePagePopup('');
    },
    onSelectClick() {
      const selectionList = this.$refs.deptTree.getSelection();

      if (selectionList.length > 0) {
        const seletedDeptList = selectionList.map(deptItem => ({
          id: deptItem.departmentId,
          value: deptItem.departmentName,
          enValue: deptItem.departmentEnglishName,
        }));

        this.closePagePopup(seletedDeptList);
      } else {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
      }
    },
  },
};
</script>

<style scoped>
</style>
